/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {CreateModelAction} from './CreateModelAction';
import {
  CreateModelActionFromJSON,
  CreateModelActionFromJSONTyped,
  CreateModelActionToJSON
} from './CreateModelAction';
import type {UpdateCalcTaskAction} from './UpdateCalcTaskAction';
import {
  UpdateCalcTaskActionFromJSON,
  UpdateCalcTaskActionFromJSONTyped,
  UpdateCalcTaskActionToJSON
} from './UpdateCalcTaskAction';
import type {UpdateModelAction} from './UpdateModelAction';
import {
  UpdateModelActionFromJSON,
  UpdateModelActionFromJSONTyped,
  UpdateModelActionToJSON
} from './UpdateModelAction';
import type {UpdateElementAction} from './UpdateElementAction';
import {
  UpdateElementActionFromJSON,
  UpdateElementActionFromJSONTyped,
  UpdateElementActionToJSON
} from './UpdateElementAction';
import type {UpdateWorkZoneJsonAction} from './UpdateWorkZoneJsonAction';
import {
  UpdateWorkZoneJsonActionFromJSON,
  UpdateWorkZoneJsonActionFromJSONTyped,
  UpdateWorkZoneJsonActionToJSON
} from './UpdateWorkZoneJsonAction';
import type {CreateElementAction} from './CreateElementAction';
import {
  CreateElementActionFromJSON,
  CreateElementActionFromJSONTyped,
  CreateElementActionToJSON
} from './CreateElementAction';
import type {DeleteElementAction} from './DeleteElementAction';
import {
  DeleteElementActionFromJSON,
  DeleteElementActionFromJSONTyped,
  DeleteElementActionToJSON
} from './DeleteElementAction';
import type {DeleteModelAction} from './DeleteModelAction';
import {
  DeleteModelActionFromJSON,
  DeleteModelActionFromJSONTyped,
  DeleteModelActionToJSON
} from './DeleteModelAction';

/**
 *
 * @export
 * @interface ActionsInner
 */
export interface ActionsInner {
  /**
   *
   * @type {any}
   * @memberof ActionsInner
   */
  workZoneJson?: any | null;
  /**
   *
   * @type {string}
   * @memberof ActionsInner
   */
  type: ActionsInnerTypeEnum;
  /**
   *
   * @type {any}
   * @memberof ActionsInner
   */
  args: any | null;
}

/**
 * @export
 */
export const ActionsInnerTypeEnum = {
  UpdateWorkZoneJson: 'update_work_zone_json',
  CreateElement: 'create_element',
  UpdateElement: 'update_element',
  DeleteElement: 'delete_element',
  CreateModel: 'create_model',
  UpdateModel: 'update_model',
  DeleteModel: 'delete_model',
  UpdateCalcTask: 'update_calc_task'
} as const;
export type ActionsInnerTypeEnum = (typeof ActionsInnerTypeEnum)[keyof typeof ActionsInnerTypeEnum];

/**
 * Check if a given object implements the ActionsInner interface.
 */
export function instanceOfActionsInner(value: object): value is ActionsInner {
  if (!('type' in value) || value['type'] === undefined) return false;
  if (!('args' in value) || value['args'] === undefined) return false;
  return true;
}

export function ActionsInnerFromJSON(json: any): ActionsInner {
  return ActionsInnerFromJSONTyped(json, false);
}

export function ActionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionsInner {
  if (json == null) {
    return json;
  }
  return {
    workZoneJson: json['work_zone_json'] == null ? undefined : json['work_zone_json'],
    type: json['type'],
    args: json['args']
  };
}

export function ActionsInnerToJSON(value?: ActionsInner | null): any {
  if (value == null) {
    return value;
  }
  return {
    work_zone_json: value['workZoneJson'],
    type: value['type'],
    args: value['args']
  };
}
